module.exports = __webpack_public_path__ + "img/icone-senior-connect_colorido-solo.19c9d216.svg";